import getScenarioStore from '../selectors/getScenarioStore';
import SuggestionSet from 'owa-search-service/lib/data/schema/SuggestionSet';
import { mutator } from 'satcheljs';
import { setCurrentSuggestions } from '../actions/publicActions';

mutator(setCurrentSuggestions, actionMessage => {
    const suggestionSet: SuggestionSet = actionMessage.suggestionSet;

    // Update suggestions in the store.
    getScenarioStore(actionMessage.scenarioId).currentSuggestions = suggestionSet;
});
